import {gql} from "apollo-angular";
import {baseResponseGraphqlField} from "../../../base.graphql";

export const currencyTypeFields = `
id
currencyUniqueId
currencyCode
currencyName
currencySymbol
currencyCentsDecimalPlaces
`


export const GET_CURRENCY_TYPES = gql`
query GetCurrencyTypes {
  getCurrencyTypes {
    ${baseResponseGraphqlField}
    data {
      ${currencyTypeFields}
    }
  }
}
`

export const CREATE_CURRENCY_TYPE = gql`
mutation CreateCurrencyTypeMutation($input: CurrencyTypeInputObjects!) {
  createCurrencyTypeMutation(input: $input) {
    ${baseResponseGraphqlField}
    data {
      ${currencyTypeFields}
    }
  }
}
`

export const UPDATE_CURRENCY_TYPE = gql`
mutation UpdateCurrencyTypeMutation($input: CurrencyTypeInputObjects) {
  updateCurrencyTypeMutation(input: $input) {
    ${baseResponseGraphqlField}
    data {
      ${currencyTypeFields}
    }
  }
}
`

export const DELETE_CURRENCY_TYPE = gql`
mutation DeleteCurrencyTypeMutation($currencyUniqueId: String!) {
  deleteCurrencyTypeMutation(currencyUniqueId: $currencyUniqueId) {
    ${baseResponseGraphqlField}
  }
}
`
